import { TableFieldModel } from '@/model/TableList'
import { numberTimes, priceWithoutRate, totalPriceWithoutRate } from '@/utils/index'
import $currency from 'currency.js'

export const TableField: TableFieldModel[] = [

  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'fee',
    isMoney: true,
    textAlign: 'right',
    fieldName: '外包费用',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'rate',
    fieldName: '外包费用税率'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'paymentAccount',
    fieldName: '付款账户',
    convert: context => {
      const { rowData } = context
      const { paymentDetails } = rowData
      if (!paymentDetails) {
        return ''
      }
      const accounts = paymentDetails.map((kk: any) => kk.account)
      // accounts = Array.from(new Set(accounts))
      return accounts.join(',')
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'paymentTime',
    fieldName: '付款日期',
    convert: context => {
      const { rowData } = context
      const { paymentDetails } = rowData
      if (!paymentDetails) {
        return ''
      }
      const dates = paymentDetails.map((kk: any) => kk.date)
      // dates = Array.from(new Set(dates)).
      return dates.join(',')
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'paymentPay',
    fieldName: '付款金额',
    convert: context => {
      const { rowData } = context
      const { paymentDetails } = rowData
      if (!paymentDetails) {
        return ''
      }
      const amounts = paymentDetails.map((kk: any) => $currency(kk.amount))
      // amounts = Array.from(new Set(amounts))
      return amounts.join(',')
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'paid',
    fieldName: '已付净额',
    isMoney: true,
    textAlign: 'right',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'refundApplyAmount',
    fieldName: '申请退款金额',
    isMoney: true,
    textAlign: 'right',
    width: 110
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'status',
    fieldName: '付款状态',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'invoiceStatus',
    fieldName: '开票状态',
    width: 140
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'invoiceType',
    fieldName: '发票类型',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '外包发票号码',
    width: 150
  },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'code',
  //   fieldName: '外包发票代码',
  //   width: 150
  // },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'checkCode',
  //   fieldName: '外包发票检查码',
  //   width: 150
  // },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'ticketAmount',
    fieldName: '外包发票金额',
    width: 150,
    convert: context => context.rowData.ticketAmount ? $currency(context.rowData.ticketAmount) : '未开票'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'outsourceCompany',
    fieldName: '外包商'
  },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'accountAlias',
  //   fieldName: '外包商账户'
  // },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'containsRate',
    fieldName: '是否含税',
    formatType: 'boolean',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerCompany',
    fieldName: '公司名称'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'ticketCompany',
    fieldName: '所属公司'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessNo',
    fieldName: '业务编号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessBrand',
    fieldName: '业务品牌'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessName',
    fieldName: '业务名称'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'salesMan',
    fieldName: '业务代表',
    width: 100,
    convert: context => {
      const { rowData } = context
      return rowData.business.salesMan
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessModel',
    fieldName: '型号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessSerial',
    fieldName: '序列号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerOrderNo',
    fieldName: '订单号码'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessUnit',
    fieldName: '单位',
    width: 60
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessAmount',
    fieldName: '数量',
    width: 80
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderTaxRate',
    fieldName: '订单税率',
    width: 80,
    convert: context => {
      const { rowData } = context
      const { orderTaxRate } = rowData.business
      if (!orderTaxRate) {
        return ''
      }
      return orderTaxRate + '%'
    }
  },
  // 业务订单税费
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee2',
    fieldName: '单价(未税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData.business
      if (!orderFee) {
        return ''
      }
      const { orderTaxRate } = rowData.business
      return priceWithoutRate(orderFee, true, orderTaxRate)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee',
    fieldName: '单价(含税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData.business
      if (!orderFee) {
        return ''
      }
      return orderFee
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee3',
    fieldName: '总价(未税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const {
        orderFee,
        orderTaxRate
      } = rowData.business
      if (!orderFee) {
        return ''
      }
      const { businessAmount } = rowData
      return totalPriceWithoutRate(orderFee, businessAmount, true, orderTaxRate)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee4',
    fieldName: '总价(含税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData.business
      if (!orderFee) {
        return ''
      }
      const { businessAmount } = rowData
      return numberTimes(orderFee, businessAmount, true)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessStatus',
    fieldName: '业务状态',
    width: 100,
    convert: context => {
      const { rowData } = context
      return rowData.business.status
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessInvoiceStatus',
    fieldName: '开票状态',
    width: 100,
    convert: context => {
      const { rowData } = context
      return rowData.business.invoiceStatus
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessReceivedStatus',
    fieldName: '收款状态',
    width: 100,
    convert: context => {
      const { rowData } = context
      return rowData.business.receivedStatus
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessRepairStatus',
    fieldName: '维修状态',
    width: 100,
    convert: context => {
      const { rowData } = context
      return rowData.business.repairStatus
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'times',
    fieldName: '申请次数',
    width: 130
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'mark',
    fieldName: '申请备注'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'account.alias',
    fieldName: '收款账户',
    convert: context => context.rowData?.account?.alias || ''
  }
]
